import { Search } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { Input } from "../ui/input";
import { useEffect, useState } from "react";

export function ObjectListSearch({ search_param }: { search_param: string }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [value, setValue] = useState<string | null>(searchParams.get(search_param) ?? null);

    useEffect(() => {
        if (searchParams && value === null) {
            setValue(searchParams.get(search_param) ?? "");
        }
    }, [searchParams]);

    const performSearch = () => {
        let _searchParams = new URLSearchParams(searchParams);
        if (value) {
            _searchParams.set(search_param, value);
        } else if (value === "" && _searchParams.has(search_param)) {
            _searchParams.delete(search_param);
        }
        _searchParams.set("page", "1"); // Reset pagination
        if (_searchParams.toString() != searchParams.toString()) {
            setSearchParams(_searchParams);
        }
    };

    return (
        <div className="md:w-[200px] lg:w-[250px]">
            <div className="relative ml-auto">
                <Input
                    type="search"
                    placeholder="Rechercher..."
                    className="w-full rounded-lg bg-background"
                    value={value ?? ""}
                    onChange={e => setValue(e.target.value)}
                    onKeyDownCapture={e => {
                        if (e.key === "Enter") performSearch();
                    }}
                    icon={Search}
                />
            </div>
        </div>
    );
}
